// Import Firebase configuration
import firebase from 'firebase/compat/app';
import 'firebase/compat/analytics';
import 'firebase/compat/firestore';

import { EVENT_TYPES } from '../../shared/settings';
import {
  slotRequestedListener,
  slotRenderEndedListener,
  impressionViewableListener,
} from './slot-event-listeners';

// Initialize Firebase if it's the selected service
const viewslotPluginConfig = window.viewslotPluginConfig || {};
if (viewslotPluginConfig.service === 'firebase' && Object.keys(viewslotPluginConfig).length > 0) {
  firebase.initializeApp(viewslotPluginConfig);
}

// Define tracked events globally so they can be accessed by addGoogleEventListener
const trackedEvents = [
  EVENT_TYPES.SLOT_REQUESTED,
  EVENT_TYPES.SLOT_RENDER_ENDED,
  EVENT_TYPES.IMPRESSION_VIEWABLE,
];

/**
 * Determine which tracking function to run
 *
 * @param {Object} eventDetails The event details to track
 *
 * @return {Promise<void>}
 */
export const runTrackingEvents = async (eventDetails) => {
  try {
    switch (viewslotPluginConfig.service) {
      case 'redpanda':
        const { sendAdEventToLambda } = await import('./redpanda');
        await sendAdEventToLambda(eventDetails);
        break;
      case 'firebase':
        const { trackFirebaseAdEvent } = await import('./firebase');
        await trackFirebaseAdEvent(eventDetails);
        break;
      case 'supabase':
        const { trackSupabaseAdEvent } = await import('./supabase');
        await trackSupabaseAdEvent(eventDetails);
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Unsupported reporting service:', viewslotPluginConfig.service);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error running tracking events:', error);
  }
};

/**
 * Generic function to add Google event listeners.
 *
 * @param {string}   eventType The type of event to listen for
 * @param {Function} handler   The event handler function
 */
export const addGoogleEventListener = (eventType, handler) => {
  if (trackedEvents.includes(eventType)) {
    window.googletag.pubads().addEventListener(eventType, handler);
  }
};

/**
 * Sends Google Ads data to the reporting tool
 */
export default function reportingTool() {
  // Return if the google tag is unavailable
  if (typeof window.googletag === 'undefined') {
    return;
  }

  // Additional check for googletag.cmd.push
  if (!window.googletag.cmd || typeof window.googletag.cmd.push !== 'function') {
    // eslint-disable-next-line no-console
    console.warn('Google Tag cmd.push is not available');
    return;
  }

  // eslint-disable-next-line no-console
  console.info('----- ViewSlot Running -----');

  // Wait for googletag to be ready and add googletag event listeners
  window.googletag.cmd.push(() => {
    slotRequestedListener();
    slotRenderEndedListener();
    impressionViewableListener();
  });
}
